import { createClient } from 'contentful';

const contentDeliveryAccesstoken = '31dwsDKnulVothFfYSNFzN6VrkCaM28J8GpUDsqlLnw';
// const contentManagrmentAccesstoken = 'CFPAT-_f63HASHgmCtCV0LkTxfjLDAabSdQEaPZO2sV5YUgLw';

export const contentfulEnvironment = createClient({
  space: '1es0unlkw916',
  accessToken: contentDeliveryAccesstoken,
  environment: 'master',
});
